'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var color = _interopDefault(require('color'));
var hastscript = _interopDefault(require('hastscript'));
var PSD = _interopDefault(require('@moyuyc/psd'));
var lodash = _interopDefault(require('lodash.get'));
var walkTree = _interopDefault(require('@moyuyc/walk-tree'));
var hastUtilToHtml = _interopDefault(require('hast-util-to-html'));

/**
 * @file psd-utils
 * @author Cuttle Cong
 * @date 2018/9/13
 *
 */

// Spec https://www.tonton-pixel.com/Photoshop%20Additional%20File%20Formats/styles-file-format.html

function clr(color$$1, opacity) {
  var c = void 0;
  if (color$$1 && color$$1.class && typeof color$$1.class.id === 'string') {
    switch (color$$1.class.id.toLowerCase()) {
      case 'rgbc':
        c = color({ r: color$$1['Rd  '], g: color$$1['Grn '], b: color$$1['Bl  '] });
        break;
      case 'hsbc':
        c = color.hsl([color$$1['H   '], color$$1['Strt'], color$$1['Brgh']]);
        break;
      case 'cmyc':
        // cmyk
        c = color.cmyk([color$$1['Cyn '], color$$1['Mgnt'], color$$1['Ylw '], color$$1['Blck']]);
        break;
      default:
        c = color(color$$1);
    }
  } else {
    c = color(color$$1);
  }

  if (opacity != null) {
    c = c.alpha(opacity / 100);
  }

  return c.string();
}

function val(data) {
  if (data && data.hasOwnProperty('value')) {
    return data.value;
  }
  return data;
}

// http://www.melanieceraso.com/psd-to-css3/
// https://github.com/finanzcheck/drop-shadow-converter/blob/master/less/drop-shadow-converter.less
function dropShadowToStyle() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      dist = _ref.dist,
      color$$1 = _ref.color,
      spread = _ref.spread,
      size = _ref.size,
      angle = _ref.angle,
      opct = _ref.opct;

  angle = val(angle);
  dist = val(dist);
  spread = val(spread);
  size = val(size);
  opct = val(opct);

  angle = (180 - angle) * Math.PI / 180;
  var offsetY = Math.round(Math.sin(angle) * dist);
  var offsetX = Math.round(Math.cos(angle) * dist);

  var spreadRadius = size * spread / 100;
  var blurRadius = size - spreadRadius;

  return {
    offsetX: offsetX,
    offsetY: offsetY,
    blurRadius: blurRadius,
    spreadRadius: spreadRadius,
    color: clr(color$$1, opct)
  };
}

var psdUtils = {
  clr: clr,
  val: val,
  dropShadowToStyle: dropShadowToStyle
};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var psdToBase64_node = createCommonjsModule(function (module) {
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var toBase64P = function (psd) {
  return Promise.resolve(psd.image.toBase64());
};

var Sep = function () {
  function Sep() {
    _classCallCheck$1(this, Sep);

    this.list = [];
  }

  Sep.prototype.push = function push(task) {
    this.list.push(task);
  };

  Sep.prototype.run = function run() {
    var p = Promise.resolve();
    this.list.forEach(function (task) {
      p = p.then(task);
    });
    return p;
  };

  return Sep;
}();

function psdToHAST(psd) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$unit = _ref.unit,
      unit = _ref$unit === undefined ? 'px' : _ref$unit,
      _ref$remStandard = _ref.remStandard,
      remStandard = _ref$remStandard === undefined ? 16 : _ref$remStandard,
      _ref$imageSplit = _ref.imageSplit,
      imageSplit = _ref$imageSplit === undefined ? false : _ref$imageSplit,
      _ref$injectImage = _ref.injectImage,
      injectImage = _ref$injectImage === undefined ? true : _ref$injectImage;

  psd.parse();

  var size = function size(px) {
    if (unit === 'rem') {
      px = px / remStandard;
    }
    return '' + px + unit;
  };

  var tree = psd.tree();
  var state = {
    hasts: []
  };

  var tasks = new Sep();
  walkTree(tree, function (node, ctx) {
    var hasts = ctx.state.hasts;

    if (node === tree) {
      return;
    }
    // Skip the hidden node
    if (!node.visible()) {
      return ctx.skip();
    }

    if (node.type === 'layer') {
      // Get radius https://github.com/layervault/psd.rb/issues/60
      // https://github.com/meltingice/psd.js/issues/83
      // https://github.com/meltingice/psd.js/issues/107
      // Spec https://www.tonton-pixel.com/Photoshop%20Additional%20File%20Formats/styles-file-format.html
      var data = {};
      var overwriteStyle = {};

      var vectorOrigination = node.get('vectorOrigination');
      var vectorStrokeContent = node.get('vectorStrokeContent');
      var vectorStroke = node.get('vectorStroke');
      var objectEffects = node.get('objectEffects');
      var solidColor = node.get('solidColor');

      // Drop Shadow
      if (objectEffects && objectEffects.data && objectEffects.data.DrSh && objectEffects.data.DrSh.enab) {
        var DrSh = objectEffects.data.DrSh;
        var d = psdUtils.dropShadowToStyle({
          dist: DrSh['Dstn'],
          color: DrSh['Clr'],
          spread: DrSh['Ckmt'],
          size: DrSh['blur'],
          angle: DrSh['lagl'],
          opct: DrSh['Opct']
        });
        Object.assign(data, {
          'data-box-shadow-offset-x': d.offsetX,
          'data-box-shadow-offset-y': d.offsetY,
          'data-box-shadow-blur-radius': d.blurRadius,
          'data-box-shadow-spread-radius': d.spreadRadius,
          'data-box-shadow-color': d.color
        });
      }

      var keyDescriptorList = lodash(vectorOrigination, 'data.keyDescriptorList');
      if (keyDescriptorList && keyDescriptorList[0]) {
        var _keyDescriptorList$ = keyDescriptorList[0],
            keyOriginRRectRadii = _keyDescriptorList$.keyOriginRRectRadii,
            keyOriginShapeBBox = _keyDescriptorList$.keyOriginShapeBBox,
            keyShapeInvalidated = _keyDescriptorList$.keyShapeInvalidated;

        if (keyOriginRRectRadii) {
          Object.assign(data, {
            'data-radius-bottom-left': keyOriginRRectRadii.bottomLeft && keyOriginRRectRadii.bottomLeft.value,
            'data-radius-bottom-right': keyOriginRRectRadii.bottomRight && keyOriginRRectRadii.bottomRight.value,
            'data-radius-top-left': keyOriginRRectRadii.topLeft && keyOriginRRectRadii.topLeft.value,
            'data-radius-top-right': keyOriginRRectRadii.topRight && keyOriginRRectRadii.topRight.value
          });
        }

        // Fix size and position
        if (keyOriginShapeBBox && !keyShapeInvalidated) {
          Object.assign(overwriteStyle, {
            left: size(psdUtils.val(keyOriginShapeBBox['Left'])),
            top: size(psdUtils.val(keyOriginShapeBBox['Top '])),
            width: size(psdUtils.val(keyOriginShapeBBox['Rght']) - psdUtils.val(keyOriginShapeBBox['Left'])),
            height: size(psdUtils.val(keyOriginShapeBBox['Btom']) - psdUtils.val(keyOriginShapeBBox['Top ']))
          });
        }
      }

      var bgColor = solidColor ? JSON.stringify(solidColor.color()) : vectorStrokeContent && psdUtils.clr(vectorStrokeContent.data['Clr ']);
      Object.assign(data, {
        'data-solid-color': bgColor
      });

      if (vectorStroke && vectorStroke.data && vectorStroke.data.strokeEnabled) {
        var _vectorStroke$data = vectorStroke.data,
            strokeStyleContent = _vectorStroke$data.strokeStyleContent,
            strokeStyleLineDashOffset = _vectorStroke$data.strokeStyleLineDashOffset,
            strokeStyleOpacity = _vectorStroke$data.strokeStyleOpacity,
            strokeStyleLineWidth = _vectorStroke$data.strokeStyleLineWidth,
            strokeStyleLineAlignment = _vectorStroke$data.strokeStyleLineAlignment,
            strokeStyleLineDashSet = _vectorStroke$data.strokeStyleLineDashSet;


        var borderColor = strokeStyleContent && psdUtils.clr(strokeStyleContent['Clr '], psdUtils.val(strokeStyleOpacity));
        var dashOffset = psdUtils.val(strokeStyleLineDashOffset);
        var lineWidth = psdUtils.val(strokeStyleLineWidth);
        var lineAlign = psdUtils.val(strokeStyleLineAlignment);

        Object.assign(data, {
          'data-stroke-dash-offset': dashOffset,
          'data-stroke-color': borderColor,
          'data-stroke-line-width': lineWidth,
          'data-stroke-line-align': lineAlign
        });
      }

      var exported = node.export();
      if (exported.text) {
        var text = exported.text;
        Object.assign(data, {
          'data-content': text.value
        });
        if (text.font) {
          var _text$font = text.font,
              _text$font$sizes = _text$font.sizes,
              sizes = _text$font$sizes === undefined ? [] : _text$font$sizes,
              names = _text$font.names,
              _text$font$leading = _text$font.leading,
              leading = _text$font$leading === undefined ? [] : _text$font$leading,
              _text$font$alignment = _text$font.alignment,
              alignment = _text$font$alignment === undefined ? [] : _text$font$alignment,
              _text$font$styles = _text$font.styles,
              _text$font$colors = _text$font.colors,
              colors = _text$font$colors === undefined ? [] : _text$font$colors,
              _text$font$lengthArra = _text$font.lengthArray,
              lengthArray = _text$font$lengthArra === undefined ? [] : _text$font$lengthArra,
              _text$font$weights = _text$font.weights,
              weights = _text$font$weights === undefined ? [] : _text$font$weights,
              _text$font$textDecora = _text$font.textDecoration,
              textDecoration = _text$font$textDecora === undefined ? [] : _text$font$textDecora;

          // TODO: Fix font size by default temporarily

          if (lengthArray.length > sizes.length && sizes.length === 0) {
            var StyleSheetData = lodash(node.get('typeTool'), 'obj.engineData.ResourceDict.StyleSheetSet.StyleSheetData');
            if (StyleSheetData && StyleSheetData[0]) {
              sizes = new Array(lengthArray.length).fill(StyleSheetData[0].FontSize);
            }
          }

          Object.assign(data, {
            'data-font-length-array': names ? JSON.stringify(lengthArray) : null,
            'data-font-family': names ? JSON.stringify(names) : null,
            'data-text-align': JSON.stringify(alignment),
            'data-font-colors': JSON.stringify(colors),
            'data-font-leading': JSON.stringify(leading),
            'data-font-sizes': JSON.stringify(sizes),
            'data-text-decoration': JSON.stringify(textDecoration),
            'data-font-weights': JSON.stringify(weights)
          });
        }
      }

      tasks.push(function () {
        var p = injectImage ? imageSplit ? toBase64P(node.layer).then(function (b64encoded) {
          return 'url(' + b64encoded + ')';
        }) : Promise.resolve(null) : Promise.resolve(null);
        return p.then(function (img) {
          var style = _extends({
            opacity: exported.opacity,
            width: size(exported.width),
            height: size(exported.height),
            left: size(exported.left),
            top: size(exported.top),
            position: 'absolute'
          }, overwriteStyle);
          if (img) {
            style['background-image'] = img;
          }
          hasts.unshift(hastscript('div.psd-layer', Object.assign({
            'data-psd-index': hasts.length,
            'data-title': exported.name,
            style: style
          }, data)));
        });
      });
    }
  }, {
    path: '_children',
    order: 'pre',
    skipVisited: false,
    // hast
    state: state
  });

  return tasks.run().then(function () {
    var b64encodedPromise = injectImage ? imageSplit ? Promise.resolve(null) : toBase64P(psd).then(function (b64encoded) {
      return 'url(' + b64encoded + ')';
    }) : Promise.resolve(null);
    return b64encodedPromise.then(function (b64encoded) {
      var style = {
        position: 'relative',
        width: size(tree.width),
        height: size(tree.height)
      };
      if (b64encoded) {
        style['background-image'] = b64encoded;
      }
      return hastscript('div#psd-root', {
        'data-hm-exclude': true,
        style: style
      }, state.hasts);
    });
  });
}

function psdToHASTFromBuffer(buffer, opts) {
  var psd = new PSD(buffer);
  return psdToHAST(psd, opts);
}

function psdToHASTFromURL(url, opts) {
  return PSD.fromURL(url).then(function (psd) {
    return psdToHAST(psd, opts);
  });
}

var psdToHast = {
  psdToHAST: psdToHAST,
  psdToHASTFromBuffer: psdToHASTFromBuffer,
  psdToHASTFromURL: psdToHASTFromURL
};

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * @file index
 * @author Cuttle Cong
 * @date 2018/9/13
 *
 */

var psdToHAST$1 = psdToHast.psdToHAST,
    psdToHASTFromBuffer$1 = psdToHast.psdToHASTFromBuffer,
    psdToHASTFromURL$1 = psdToHast.psdToHASTFromURL;


function psdToHtmlFromBuffer(buffer) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var toHtmlOpts = _ref.toHtmlOpts,
      opts = _objectWithoutProperties(_ref, ['toHtmlOpts']);

  return psdToHASTFromBuffer$1(buffer, opts).then(function (hast) {
    return hastUtilToHtml(hast, toHtmlOpts);
  });
}

function psdToHtml(psd) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var toHtmlOpts = _ref2.toHtmlOpts,
      opts = _objectWithoutProperties(_ref2, ['toHtmlOpts']);

  return psdToHAST$1(psd, opts).then(function (hast) {
    return hastUtilToHtml(hast, toHtmlOpts);
  });
}

function psdToHtmlFromURL(url) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var toHtmlOpts = _ref4.toHtmlOpts,
      opts = _objectWithoutProperties(_ref4, ['toHtmlOpts']);

  return psdToHASTFromURL$1(url, opts).then(function (hast) {
    return hastUtilToHtml(hast, toHtmlOpts);
  });
}

var lib = {
  psdToHtml: psdToHtml,
  psdToHtmlFromBuffer: psdToHtmlFromBuffer,
  psdToHtmlFromURL: psdToHtmlFromURL,
  psdToHASTFromURL: psdToHASTFromURL$1,
  psdToHAST: psdToHAST$1,
  psdToHASTFromBuffer: psdToHASTFromBuffer$1
};

module.exports = lib;
//# sourceMappingURL=psd-html.browser.cjs.js.map
